export default componentWidth => {
  var width = '';

  if (componentWidth) {
    let desktopDefalut = 'md';
    if (componentWidth.tabletComponentWidth) {
      desktopDefalut = 'lg';
    }
    if (componentWidth.smartphoneComponentWidth === 'FullBleed') {
      width = `w-full`;
    } else {
      width = `w-${componentWidth.smartphoneComponentWidth}/12`;
    }

    if (componentWidth.tabletComponentWidth === 'FullBleed') {
      width += ` md:w-full`;
    } else if (componentWidth.tabletComponentWidth != null) {
      width += ` md:w-${componentWidth.tabletComponentWidth}/12`;
    }

    if (componentWidth.desktopComponentWidth === 'FullBleed') {
      width += ` ${desktopDefalut}:w-full`;
    } else {
      width += ` ${desktopDefalut}:w-${
        componentWidth.desktopComponentWidth
      }/12`;
    }
  }
  return width;
};
